export interface HorizontalBarChartTooltipType {
  x: number
  y: number
  connectorX: number
  content: JSX.Element | null
  visible: boolean
  type: string
}

export interface TooltipInfoItem {
  label: string
  value: number | string
  link?: string
}

export enum StackedBarChartTooltipType {
  Inline = 'inline',
  Detailed = 'detailed',
  Table = 'table',
}

export type BarChartSegment = {
  label: string
  value: number
  color: string
  ariaLabel?: string
  tooltipType?: StackedBarChartTooltipType
  tooltipInfo?: string | TooltipInfoItem[]
}

export type BarChartSegmentWithWidth = BarChartSegment & {
  width: number
  xPosition?: number
}

export type BarChartSegmentsWithWidth = BarChartSegmentWithWidth[]
